module.exports = __webpack_public_path__ + "img/icon_chip_02.f49495a1.png";